export interface CompletedSessions {
  beginDate: Date
  endDate: Date
  nbSessions: number
}

export enum Periodicity {
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  YEARLY = "ANNUALLY",
}
